let Global = {
    setUserName: () => {
        Cookies.set(
            'username',
            +new Date() + '_' + parseInt(Math.random() * 999999),
            {
                expires: 365 * 2,
                path: '/',
                domain: location.hostname
                    .split('.')
                    .slice(-2)
                    .join('.'),
            }
        );
    },
    getUserName: () => {
        return Cookies.get('username');
    },

    bonus: {
        '段奥娟签名抱枕': {
            deg: 45 * 2,
        },
        '段奥娟签名照': {
            deg: 45 * 7,
        },
        '联名笔记本': {
            deg: 45 * 1,
        },
        '联名立体便签': {
            deg: 45 * 3,
        },
        '联名团扇': {
            deg: 45 * 0,
        },
        '联名渔夫帽': {
            deg: 45 * 5,
        },
        '梦幻花园音乐盒': {
            deg: 45 * 6,
        },
    },
    curr: {},
    yubi: {
        ssq: {},
        qsy: {},
        aj: {},
        ytx: {},
    },

    audio_click: new Audio(`//cdn.original-fun.com/gugong/btn-click.mp3`),
    clickSound() {
        this.audio_click.currentTime = 0;
        this.audio_click.play();
    },
    audio_intor: {
        aj_music: new Audio('//cdn.original-fun.com/gugong/模糊女子歌声.mp3'),
        aj: new Audio('//cdn.original-fun.com/gugong/阿杰线-1-intor.mp3'),
        qsy: new Audio('//cdn.original-fun.com/gugong/乔诗语线-1-intor.mp3'),
        ytx: new Audio('//cdn.original-fun.com/gugong/杨天翔线-1-intor.mp3'),
        ssq: new Audio('//cdn.original-fun.com/gugong/苏尚卿线-1-intor.mp3'),
    },

    audioIntorMetaInfo: {
        aj: {
            s1: {
                start: 0.2,
                end: 3,
            },
            s2: {
                start: 3,
                end: 16,
            },
        },
        qsy: {
            s1: {
                start: 2,
                end: 5.1,
            },
            s2: {
                start: 8.4,
                end: 16,
            },
        },
        ytx: {
            s1: {
                start: 0.7,
                end: 2.1,
            },
            s2: {
                start: 2.2,
                end: 16,
            },
        },
        ssq: {
            s1: {
                start: 0.45,
                end: 5,
            },
            s2: {
                start: 6,
                end: 15,
            },
        },
    },
    loadOne(audioKey) {
        const audioDom = this.audio[audioKey];
        audioDom.play();
        audioDom.pause();
    },
    audioIntorPauseAll() {
        this.audio_intor['aj'].pause();
        this.audio_intor['qsy'].pause();
        this.audio_intor['ytx'].pause();
        this.audio_intor['ssq'].pause();
        this.audio_intor['aj_music'].pause();
    },
    startIntorPlay(nameID, sceneID) {
        this.audioIntorPauseAll();
        let audioDOM = this.audio_intor[nameID];
        let cfg = this.audioIntorMetaInfo[nameID][sceneID];
        audioDOM.pause();
        audioDOM.currentTime = cfg.start;
        // audioDOM.fastSeek(cfg.start);
        audioDOM.play();
        audioDOM.removeEventListener('timeupdate', audioDOM.func);
        audioDOM.func = e => {
            if (audioDOM.currentTime >= cfg.end) {
                audioDOM.pause();
                audioDOM.removeEventListener('timeupdate', audioDOM.func);
            }
        };
        audioDOM.addEventListener('timeupdate', audioDOM.func);
    },

    audio: {
        aj: new Audio('//cdn.original-fun.com/gugong/阿杰线-2.mp3'),
        qsy: new Audio('//cdn.original-fun.com/gugong/乔诗语线-2.mp3'),
        ytx: new Audio('//cdn.original-fun.com/gugong/杨天翔线-2.mp3'),
        ssq: new Audio('//cdn.original-fun.com/gugong/苏尚卿线-2.mp3'),
    },
    bgm: new Audio('//cdn.original-fun.com/gugong/故宫H5背景音乐.mp3'),
    audioMetaInfo: {
        ssq: {
            scene1: {
                start: 0,
                end: 13,
            },
            scene2: {
                start: 13.5,
                end: 17,
            },
            scene3: {
                start: 18.5,
                end: 21,
            },
            scene4: {
                start: 21,
                end: 32.4,
            },
            scene5: {
                start: 32.4,
                end: 42,
            },
            scene6: {
                start: 42,
                end: 47,
            },
            scene7: {
                start: 48,
                end: 52,
            },
            scene8: {
                start: 52,
                end: 61.7,
            },
            scene9: {
                start: 62,
                end: 71,
            },
            scene10: {
                start: 71,
                end: 74,
            },
            scene11: {
                start: 74,
                end: 76,
            },
            scene12: {
                start: 76.5,
                end: 95,
            },
            scene13: {
                start: 95,
                end: 102,
            },
            scene14: {
                start: 103,
                end: 113,
            },
            scene15: {
                start: 113,
                end: 128,
            },
            scene16: {
                start: 129,
                end: 144,
            },
        },
        qsy: {
            scene1: {
                start: 0,
                end: 8.88,
            },
            scene2: {
                start: 8.88,
                end: 21,
            },
            scene2_1: {
                start: 21.2,
                end: 26.6,
            },
            scene3: {
                start: 27.2,
                end: 41.6,
            },
            scene4: {
                start: 42.5,
                end: 47.3,
            },
            scene5: {
                start: 48.6,
                end: 63.9,
            },
            scene6: {
                start: 66.1,
                end: 72.1,
            },
            scene7: {
                start: 74.9,
                end: 86.4,
            },
            scene8: {
                start: 87.5,
                end: 101,
            },
            scene9: {
                start: 101,
                end: 111.9,
            },
            scene10: {
                start: 112.8,
                end: 117.3,
            },
            scene11: {
                start: 118.8,
                end: 125.5,
            },
            scene12: {
                start: 126.6,
                end: 137.9,
            },

            scene13: {
                start: 139,
                end: 153,
            },
            scene13_2: {
                start: 153,
                end: 161,
            },
            scene13_3: {
                start: 161,
                end: 164,
            },
            scene14: {
                start: 164,
                end: 178.8,
            },
            scene15: {
                start: 179,
                end: 190.7,
            },
        },
        aj: {
            scene1: {
                start: 0,
                end: 12.7,
            },
            scene2: {
                start: 14.9,
                end: 18.4,
            },
            scene3: {
                start: 21,
                end: 23.6,
            },
            scene4: {
                start: 25.5,
                end: 31,
            },
            scene5: {
                start: 32.4,
                end: 48.6,
            },
            scene6: {
                start: 49.4,
                end: 56.2,
            },
            scene7: {
                start: 57.4,
                end: 63.8,
            },
            scene7_5: {
                start: 62,
                end: 63.8,
            },
            scene8: {
                start: 64.6,
                end: 78.5,
            },
            scene9: {
                start: 78.4,
                end: 97.7,
            },
            scene10: {
                start: 98,
                end: 102.7,
            },
            scene11: {
                start: 103.2,
                end: 111.3,
            },
            scene10_11: {
                start: 98,
                end: 111.3,
            },

            scene12: {
                start: 111.8,
                end: 122.8,
            },
            scene13: {
                start: 123.2,
                end: 133.1,
            },
        },
        ytx: {
            scene1: {
                start: 0,
                end: 18,
            },
            scene1_1: {
                start: 18.2,
                end: 31,
            },
            scene2_1: {
                start: 31,
                end: 38.3,
            },
            scene2: {
                start: 38.8,
                end: 46,
            },
            scene3: {
                start: 46.4,
                end: 55,
            },
            scene4: {
                start: 55.6,
                end: 67.8,
            },
            scene4_1: {
                start: 68,
                end: 74,
            },
            scene4_2: {
                start: 74,
                end: 82.1,
            },
            //   scene4_1: {
            //     start: 68,
            //     end: 82.1,
            //   },
            scene5: {
                start: 82.6,
                end: 101.2,
            },
            scene6: {
                start: 102.8,
                end: 106.5,
            },
            scene7: {
                start: 107.2,
                end: 120,
            },
            scene7_1: {
                start: 120,
                end: 131.2,
            },
            scene7_2: {
                start: 131.5,
                end: 135,
            },
            scene8: {
                start: 136.5,
                end: 151.7,
            },
            scene9: {
                start: 152.2,
                end: 169.3,
            },
            scene10: {
                start: 169.5,
                end: 193.2,
            },
            scene11: {
                start: 194.2,
                end: 201.4,
            },

            scene12: {
                start: 208,
                end: 212.6,
            },
            scene13: {
                start: 213.9,
                end: 228.4,
            },
            scene14: {
                start: 228.9,
                end: 240.7,
            },
        },
    },

    startBgm() {
        this.bgm.loop = true;
        this.bgm.play();
    },
    pauseBgm() {
        Global.bgm.loop = true;
        this.bgm.pause();
    },

    startPlay(nameID, sceneID) {
        let audioDOM = this.audio[nameID];
        let cfg = this.audioMetaInfo[nameID][sceneID];
        audioDOM.pause();
        audioDOM.currentTime = cfg.start;
        // audioDOM.fastSeek(cfg.start);
        audioDOM.play();

        audioDOM.removeEventListener('timeupdate', audioDOM.func);

        audioDOM.func = e => {
            if (audioDOM.currentTime >= cfg.end) {
                audioDOM.pause();
                audioDOM.removeEventListener('timeupdate', audioDOM.func);
            }
        };
        audioDOM.addEventListener('timeupdate', audioDOM.func);
    },
    pause(nameID) {
        let audioDOM = this.audio[nameID];
        audioDOM.pause();
    },
    pauseAll() {
        this.pause('ssq');
        this.pause('aj');
        this.pause('qsy');
        this.pause('ytx');
    },

    loadingBaseUrl: '//cdn.original-fun.com/gugong/',

    loadingData: {
        cv1: [
            '乔诗语-吉象.png',
            '乔诗语.png',
            '乔诗语讲解.png',
            '答错提示框.png',
            '答题后-乔诗语.png',
            '场景解说小亭子装饰.png',
            '场景解说白底.png',
            '场景解说装饰.png',
            '顺贞门.jpg',
            '承光门.jpg',
            '延辉阁.jpg',
            '位育斋.jpg',
            '公公npc.png',
            '宫女.png',
            '对勾.png',
            '庄士敦配图.png',
            '找狗选项1.png',
            '找狗选项2.png',
            '找狗选项3.png',
            '找狗选项4.png',
            '方形小图框选.png',
            '皇子.png',
            '答题弹框.png',
            '答题未选中按钮.png',
            '答题选中按钮.png',
            '纯文字题框.png',
            '获得玉璧.png',
            '贵妃.png',
        ],   //乔诗语
        cv2: [
            '琼苑东门.jpg',
            '绛雪轩.jpg',
            '万春亭.jpg',
            '万春亭配图.png',
            '万春亭配图1.png',
            '万春亭配图2.png',
            '万春亭配图3.png',
            '浮碧亭.jpg',
            '公公npc.png',
            '场景解说小亭子装饰.png',
            '场景解说白底.png',
            '场景解说装饰.png',
            '宫女.png',
            '对勾.png',
            '庄士敦配图.png',
            '找狗选项1.png',
            '找狗选项2.png',
            '找狗选项3.png',
            '找狗选项4.png',
            '方形小图框选.png',
            '皇子.png',
            '答错提示框.png',
            '答题后-苏尚卿.png',
            '答题弹框.png',
            '答题未选中按钮.png',
            '答题选中按钮.png',
            '纯文字题框.png',
            '苏尚卿线.mp3',
            '苏尚卿讲解.png',
            '获得玉璧.png',
            '贵妃.png',
            '锦鲤1.png',
            '锦鲤2.png',
            '锦鲤3.png',
            '锦鲤上层遮罩.png',
            '锦鲤底图.png',
        ], //苏尚卿
        cv3: [
            '坤宁门.jpg',
            '天一门.jpg',
            '钦安殿.jpg',
            '御景亭.jpg',
            '公公npc.png',
            '场景解说小亭子装饰.png',
            '场景解说白底.png',
            '场景解说装饰.png',
            '宫女.png',
            '对勾.png',
            '庄士敦配图.png',
            '方形小图框选.png',
            '皇子.png',
            '答错提示框.png',
            '答题弹框.png',
            '答题未选中按钮.png',
            '答题选中按钮.png',
            '纯文字题框.png',
            '获得玉璧.png',
            '贵妃.png',
        ], //阿杰
        cv4: [
            '琼苑西门.jpg',
            '养性斋.jpg',
            '千秋亭.jpg',
            '千秋亭配图.png',
            '千秋亭配图2.png',
            '澄瑞亭.jpg',
            '公公npc.png',
            '场景解说小亭子装饰.png',
            '场景解说白底.png',
            '场景解说装饰.png',
            '宫女.png',
            '对勾.png',
            '庄士敦配图.png',
            '方形小图框选.png',
            '杨天翔.png',
            '皇子.png',
            '答错提示框.png',
            '答题弹框.png',
            '答题未选中按钮.png',
            '答题选中按钮.png',
            '纯文字题框.png',
            '获得玉璧.png',
            '贵妃.png'
        ],//杨天翔
    },
};

window.Global = Global;
export default Global;
